import { render, staticRenderFns } from "./WizardForm.vue?vue&type=template&id=4f5b4d97&"
import script from "./WizardForm.vue?vue&type=script&lang=js&"
export * from "./WizardForm.vue?vue&type=script&lang=js&"
import style0 from "./WizardForm.vue?vue&type=style&index=0&id=4f5b4d97&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports